/*!
 * search-external.js
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */
const HotelAgent = {
	FormatDate: (lang, inputDate) => {
		let inputFormat = lang == 'en' ? 'MM.DD.YYYY' : 'DD.MM.YYYY';
		const parsedDate = moment(inputDate, inputFormat, true);
		if (parsedDate.isValid()) { return parsedDate.format('YYYY-MM-DD'); }
		return 'Invalid Date';
	},
	GetHotel: (param) => {
		const HotelIDMappings = [
			{ id: 15, title: 'The Norm Collection Door’a', code: 'SWED3R9SS7BV', subdomain: 'thenormcollectiondoora' },
			{ id: 16, title: 'The Norm Oriental', code: '6171703FE0F1', subdomain: 'thenormoriental' },
		].reduce((acc, hotel) => { acc[hotel.id] = hotel; acc[hotel.code] = hotel; return acc; }, {})

		return HotelIDMappings[param] || HotelIDMappings[15];
	},
	GetLanguageID: (lang) => {
		const LanguageIDMappings = { 'en': 'en', 'tr': 'tr', 'de': 'de', 'ru': 'ru' };
		return LanguageIDMappings[lang.toLowerCase()] || 'tr';
	},
	GetParams: (p) => {
		return {
			hotelId: HotelAgent.GetHotel(p["HotelId"]).code,
			checkIn: HotelAgent.FormatDate(lang, p["CheckIn.Date"]),
			checkOut: HotelAgent.FormatDate(lang, p["CheckOut.Date"]),
			adult_1: p["AdultsCount"],
			child_1: p["ChildrenCount"],
			...(() => {
				const childAgesParams = {};
				const childCount = p["ChildrenCount"];
				for (let i = 1; i <= childCount; i++) { childAgesParams[`childage_1_${i}`] = p[`childAge${i}`]; }
				return childAgesParams;
			})(),
			Lang: HotelAgent.GetLanguageID(lang),
		}
	},
	GetPathname: (lang) => { return lang === 'tr' ? '/arama-sonuclari' : '/search-result'; },
	GenerateExternalURL: (p) => {
		const { subdomain } = HotelAgent.GetHotel(p["hotelId"])
		const pathname = HotelAgent.GetLanguageID(lang) + HotelAgent.GetPathname(lang)
		
		const url = new URL(`https://${subdomain}.hotelagent.com`);
		url.pathname = pathname;

		for (const [key, value] of Object.entries(p)) { url.searchParams.append(key, value); }
		return url.toString();
	}
}

const ExternalSearch = function (params, target) {
	window.open(HotelAgent.GenerateExternalURL(HotelAgent.GetParams(params)), (target || '_blank'))
}